<div class="calendar-dialog-box">
  <div class="calendar-container" style="padding: 0.5rem">
    <div class="range-header">
      <div class="row">
        <h2>Select the date range</h2>
        <button mat-icon-button aria-label="close dialog" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <app-monthly />
    <div class="footer">
      <div class="button-container">
        <button (click)="clear()" tabindex="-1" class="primary">Clear</button>
        <button (click)="save()" color="primary" class="fill">Apply</button>
      </div>
    </div>
  </div>
</div>
